export const STATUS_ACTIVE = 1;
export const STATUS_INACTIVE = -1;

export const statusFormat = val => {
    switch (val) {
        case STATUS_ACTIVE:
            return '激活';
        case STATUS_INACTIVE:
            return '冻结';
    }
};

export const STATUS_YES = 1;
export const STATUS_NO = 0;
export const statusNewFormat = val => {
    switch (val) {
        case STATUS_YES:
            return '启用';
        case STATUS_NO:
            return '停用';
    }
	 return '';
};

export const STATUS_ACCEPT_YES = 1;
export const STATUS_ACCEPT_NO = 0;
export const statusAcceptFormat = val => {
    switch (val) {
        case STATUS_ACCEPT_YES:
            return '是';
        case STATUS_ACCEPT_NO:
            return '否';
    }
	 return '';
};

export const About_NO = 1;
export const About_YES = 0;
export const aboutFormat = val => {
    switch (val) {
        case About_NO:
            return '启用';
        case About_YES:
            return '停用';
    }
	 return '';
};

export const CONTACT_NO = 1;
export const CONTACT_YES = 0;
export const contactFormat = val => {
    switch (val) {
        case CONTACT_NO:
            return '启用';
        case CONTACT_YES:
            return '停用';
    }
	 return '';
};

export const APPROVAL_NO = 0;
export const APPROVAL_YES = 1;
export const APPROVAL_INREVIEW = 2;

export const approvalFormat = val => {
    switch (val) {
        case APPROVAL_NO:
            return '未通过';
        case APPROVAL_YES:
            return '通过';
        case APPROVAL_INREVIEW:
            return '审核中';
    }

    return '';
};

export const REGION_GRADE_PROVINCE = 1;
export const REGION_GRADE_CITY = 2;
export const REGION_GRADE_AREA = 3;

export const regionGradeFormat = val => {
    switch (val) {
        case REGION_GRADE_PROVINCE:
            return '省';
        case REGION_GRADE_CITY:
            return '市';
        case REGION_GRADE_AREA:
            return '区县';
    }
    return '';
};

export const getapprovalFormatOptions = val => {
    return [
        { value: APPROVAL_NO, key: '未通过' },
        { value: APPROVAL_YES, key: '通过' },
        { value: APPROVAL_INREVIEW, key: '审核中' }
    ];
};
export const DELIVERYWAYS_SELFMENTION = 0;
export const DELIVERYWAYS_TRANSFERSTATION = 1;
export const DELIVERYWAYS_LOGISTICS = 2;
export const deliveryWaysFormat = val => {
    switch (val) {
        case DELIVERYWAYS_SELFMENTION:
            return '客户自提';
        case DELIVERYWAYS_TRANSFERSTATION:
            return '转运站';
        case DELIVERYWAYS_LOGISTICS:
            return '物流';
    }

    return '';
};

export const approvalColor = val => {
    switch (val) {
        case APPROVAL_NO:
            return 'error';
        case APPROVAL_YES:
            return 'success';
        case APPROVAL_INREVIEW:
            return 'warning';
    }

    return '';
};

export const FRONTEND_HIDE = 0;
export const FRONTEND_SHOW = 1;

export const frontendFormat = val => {
    switch (val) {
        case FRONTEND_HIDE:
            return '隐藏';
        case FRONTEND_SHOW:
            return '显示';
    }
};

export const PRICE_APPROVAL_NO = 0;
export const PRICE_APPROVAL_YES = 1;

export const priceApprovalFormat = val => {
    switch (val) {
        case PRICE_APPROVAL_NO:
            return '暂停';
        case PRICE_APPROVAL_YES:
            return '通过';
    }

    return '';
};

export const WEIXIN = "Weixin";
export const ALIPAY = "Alipay";

export const payTypeFormat = val => {
    switch (val) {
        case WEIXIN:
            return '微信';
        case ALIPAY:
            return '支付宝';
    }

    return '';
};

export const STATUS = val =>{
    switch (val) {
        case true:
            return '正常';
        case false:
            return '禁用';
    }
};